import { useEffect } from 'react';

import { Grid, Typography } from '@mui/material';

import { Page } from '@/types/generated';
import { ComponentResolver } from '@/components/ComponentResolver';
import { ImagePriorityContext } from '@/utils/images/imageOptimization';

import LazyHydrate from '../LazyHydrate/LazyHydrate';
import { ComponentProps } from '../ComponentResolver/ComponentResolver';
interface INextPage {
	pageData: Page;
}

export default function NextPage({ pageData }: Readonly<INextPage>) {
	const { contentsCollection, pageTitle, redirectTo, tags } = pageData;

	useEffect(() => {
		if (!redirectTo) {
			return;
		}
		const delay = 1;
		const redirectTimeout = setTimeout(() => {
			window.location.replace(`${redirectTo}`);
		}, delay);

		return () => clearTimeout(redirectTimeout);
	}, [redirectTo]);

	return (
		<div data-testid="design_system_next_page">
			{pageTitle ? (
				<Grid container alignItems="center" wrap="nowrap">
					<Typography variant="header1" color="primary" data-testid="text_page_title">
						{pageTitle}
					</Typography>
				</Grid>
			) : null}

			{contentsCollection?.items?.map((content, idx) => {
				if (!content?.__typename || Object.keys(content).length <= 2) {
					console.warn(
						`⚠️⚠️⚠️ Shared Components Web - No content __typename found for ${
							content?.sys?.id ?? 'Unknown entryId'
						} ⚠️⚠️⚠️`
					);
					return null;
				}

				return (
					<ImagePriorityContext.Provider key={`${content.sys.id}-${content.__typename}-${idx}`} value={idx}>
						{idx > 1 ? (
							<LazyHydrate whenVisible>
								<ComponentResolver
									data-index={idx}
									componentProps={content as ComponentProps}
									typename={content.__typename}
									// tags={tags as Array<string>}
								/>
							</LazyHydrate>
						) : (
							<ComponentResolver
								data-index={idx}
								componentProps={content as ComponentProps}
								typename={content.__typename}
								tags={tags as Array<string>}
							/>
						)}
					</ImagePriorityContext.Provider>
				);
			}) ?? null}
		</div>
	);
}
